import React, { memo } from "react";
import { StatusPillProps } from "../types";
import { COLORS } from "../constants";

const STATUS_STYLES: Record<
  StatusPillProps["status"],
  { background: string; color: string }
> = {
  PENDING: {
    background: COLORS.STATUS_PENDING_BG,
    color: COLORS.STATUS_PENDING_TEXT,
  },
  APPROVED: {
    background: COLORS.STATUS_APPROVED_BG,
    color: COLORS.STATUS_APPROVED_TEXT,
  },
  REJECTED: {
    background: COLORS.STATUS_REJECTED_BG,
    color: COLORS.STATUS_REJECTED_TEXT,
  },
  REWORK: {
    background: COLORS.STATUS_REWORKED_BG,
    color: COLORS.STATUS_REWORKED_TEXT,
  },
};

// Matches main listing "btn-secondary" for unknown statuses (e.g. SALARY_DATA_REQUIRED)
const DEFAULT_STYLE = {
  background: COLORS.STATUS_DEFAULT_BG,
  color: COLORS.STATUS_DEFAULT_TEXT,
};

const StatusPill: React.FC<StatusPillProps> = ({ status }) => {
  const style = status ? STATUS_STYLES[status as StatusPillProps["status"]] : undefined;
  const { background, color } = style ?? DEFAULT_STYLE;
  const label =
    typeof status === "string" && status.length > 0
      ? `${status.charAt(0).toUpperCase()}${status.slice(1)}`
      : "-";

  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        padding: "5px 18px",
        borderRadius: 9999,
        fontSize: 16,
        fontWeight: 400,
        background,
        color,
      }}
    >
      {label}
    </div>
  );
};

export default memo(StatusPill);
